import {put, takeLatest} from "redux-saga/effects";
import axiosCustom from "../../../common/components/apiConfig";
import {
    handleNotificationAlertCatch,
    handleNotificationAlertTrySelect
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
    selectOptionsMarketMap: "[selectOptionsMarketMap] Action",
    selectOptionsMarketMapLoading: "[selectOptionsMarketMapLoading] Action",
    selectOptionsMarketMapAsync: "[selectOptionsMarketMapAsync] Action"
};

const initialState = {
    data: [],
    size: 10,
    total: 0,
    loading: false
};

export const select_options_market_map_reducer = (
    state = initialState,
    {type, payload}
) => {
    switch (type) {
        case actionTypes.selectOptionsMarketMap:
            return {
                ...state,
                data: payload.results,
                total: payload.total
                    ? payload.total > 10000
                        ? 10000
                        : payload.total
                    : 0
            };
        case actionTypes.selectOptionsMarketMapLoading:
            return {
                ...state,
                loading: payload
            };
        default:
            return state;
    }
};


function* handleWorker({payload}) {
    yield put({type: actionTypes.selectOptionsMarketMapLoading, payload: true});

    let config = {
        url: "select_request"
    };

    let data = {
        table: "option",
        method_type: "select_options_market_map",
        data: {
            type: payload?.methodType,
            param: payload?.param ? payload?.param : "trades_value",
        },
    };

    try {
        let res = yield axiosCustom(config, data);

        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) return;

        yield put({
            type: actionTypes.selectOptionsMarketMap,
            payload: res.data.response.data
        });
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({type: actionTypes.selectOptionsMarketMapLoading, payload: false});
    }
}

export function* SelectOptionsMarketMap() {
    yield takeLatest(actionTypes.selectOptionsMarketMapAsync, handleWorker);
}